module.exports = __webpack_public_path__ + "static/a-xx-153-art-8c0d32e0819e461fd96da5002ce04c73.jpg";